export default __webpack_public_path__ + "static/media/6.043e48cb.jpg";